import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../../core/services/profile.service';
import { UtilityService } from '../../core/services/utility.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileInfo } from '../../core/models/profile-info';
import { ProfileImageUpload } from '../../core/models/profile-image-upload';
import { FormBuilder, FormGroup, Validators, AbstractControl} from '@angular/forms';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  providers:[ProfileService,UtilityService]
})
export class ProfileComponent implements OnInit {

  profileForm: FormGroup;
  errorMessage:string[];
  isError :boolean = false;
  confirmMessage:string = null;

  nameClass:string;
  emailClass:string;
  phoneClass:string;
  aboutClass:string;

  selectedFiles: FileList;

  profileStoragePath: string;
  profileInfo = new ProfileInfo();

  currentFileUpload : ProfileImageUpload;
  progress: {percentage: number} = {percentage: 0}

  constructor(private profileService: ProfileService, private utilityService: UtilityService
    ,private fb: FormBuilder) {
    
      this.profileForm = fb.group({
      'name' :  ['', Validators.compose([Validators.required, Validators.minLength(3)])],
      'about' : ['',Validators.compose([Validators.required, Validators.minLength(10)])],
      'phoneNo' : ['', Validators.compose([Validators.required,Validators.pattern('[6-9]{2}[0-9]{8}')])],
      'email' : ['', Validators.compose([Validators.required, Validators.email])],
    });
    this.clearClasses();
    this.setUserName();
  }

  setUserName(){
    this.profileService.getUserProfile().subscribe(item=>{
      //console.log(item);
      if(item){
        //this.email = this.profileInfo.email = item.email;
        if(item.profileImageUri){
          this.profileStoragePath = this.profileInfo.profileImageUri = item.profileImageUri;
        }
        this.profileForm.patchValue({
          name: item.name,
          about: item.about,
          email: item.email,
          phoneNo: item.phoneNo,
        });
        this.profileInfo = item;
        //console.log(this.profileInfo);
      }
    });
  }

  ngOnInit() {
    
  }

  // File Upload Event occured 
  detectFiles(event) {
    this.selectedFiles = event.target.files;
  }

  uploadSingle() {
    let file = this.selectedFiles.item(0)
    //console.log(this.profileForm.get('email').value);
    this.currentFileUpload = new ProfileImageUpload(file);
    this.profileService.pushUpload(this.currentFileUpload, this.profileForm.get('email').value, this.profileInfo);
    this.confirmMessage = 'File Uploaded successfully';
    
  }

  // File Upload Event occured
  //Delete Profile Image from Database and Storage
  
  deleteProfileFile() {
    this.profileInfo.email = this.profileForm.get('email').value;
    let infoEmail = this.profileInfo.email.replace(/\./g,',');
    this.profileService.deleteFileStorage(this.profileStoragePath, infoEmail, this.profileInfo);
    this.confirmMessage = 'Profile successfully Deleted';
  }
  
  submitProfile(data) {

      this.isError = false;
      this.errorMessage = new Array();
      this.clearClasses();
      this.confirmMessage = null;

      if(this.profileForm.valid ) {
        this.profileInfo.name = data.name;
        this.profileInfo.email = data.email;
        this.profileInfo.about = data.about;
        this.profileInfo.phoneNo = data.phoneNo;
        let infoEmail = this.profileInfo.email.replace(/\./g,',');

        this.profileInfo.updatedAt = new Date().getTime();
        this.profileService.updateProfileInfo(this.profileInfo, infoEmail);
        this.confirmMessage = 'User updated successfully';
      } else { 
        this.isError = true;
        this.validator();
      }
  }

  validator(){
    if(this.profileForm.get('email').value == ""){
      this.errorMessage.push('Email can not be empty');
      this.emailClass = "form-control fieldWithErrors";
    } else if(!this.profileForm.get('email').valid){
      this.errorMessage.push('Email is not valid');
      this.emailClass = "form-control fieldWithErrors";
    } 

    if(this.profileForm.get('name').value == ""){
      this.errorMessage.push('Name can not be empty');
      this.nameClass = "form-control fieldWithErrors";
    } else if(!this.profileForm.get('name').valid){
      this.errorMessage.push('Name should have least 3 characters');
      this.nameClass = "form-control fieldWithErrors";
    }

    if(this.profileForm.get('phoneNo').value == ""){
      this.errorMessage.push('PhoneNo can not be empty');
      this.phoneClass = "form-control fieldWithErrors";
    } else if(!this.profileForm.get('phoneNo').valid){
      this.errorMessage.push('Phone Number is not valid');
      this.phoneClass = "form-control fieldWithErrors";
    }

    if(this.profileForm.get('about').value == "") {
      this.errorMessage.push('Description can not be empty');
      this.aboutClass = "form-control fieldWithErrors";
    } else if(!this.profileForm.get('about').valid) {
      this.errorMessage.push('Description should have least 10 characters');
      this.aboutClass = "form-control fieldWithErrors";
    }

  }
  clearClasses(){
    this.nameClass = 'form-control';
    this.emailClass = 'form-control';
    this.phoneClass = 'form-control';
    this.aboutClass = 'form-control';
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/user/profile/profile.component.ts